<template>
  <!-- Vi labels-->
  <span>
    <v-card text v-if="showCard && count">
      <v-toolbar>
        <v-toolbar-title>
          <logo name="fid" small></logo>
          <span class="caption ml-1">
            {{ labelCaption }}
          </span>
          <span v-if="showff" class="ml-2">
            <v-tooltip right color="accent" content-class="caption" :close-delay="tooltips.closeDelay"
              :open-on-hover="true" :transition="tooltips.transition">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon :color="getIconColor('play')" @click="flipReview('play')">
                    {{ getIcon(isReviewing ? 'stop' : 'play') }}
                  </v-icon>
                </span>
              </template>
              <span v-if="isReviewing">Stop reviewing at current label and pause film</span>
              <span v-else>Skip through labels and play film segment</span>
            </v-tooltip>

            <v-tooltip v-if="!isReviewing" right color="accent" content-class="caption"
              :close-delay="tooltips.closeDelay" :open-on-hover="true" :transition="tooltips.transition">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon :color="getIconColor('ff')" @click="flipReview('ff')">
                    {{ getIcon(isReviewing ? 'stop' : 'ff') }}
                  </v-icon>
                </span>
              </template>
              <span>Skip through labels quickly and review stills</span>
            </v-tooltip>
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <tool-chip-count :count="count" class="mr-1" :tooltip="`${count} ${labelCaption} labels`"
          left></tool-chip-count>

        <hide-detail :prop-name="labelType" :tooltip="labelCaption" left :hide="!showCardDetail"
          @hide="hide"></hide-detail>
      </v-toolbar>

      <v-card-text v-if="showCardDetail" class="text-xs-center">
        <span v-if="filterCount">
          <span v-if="labelType === 'transcript'">
            <div v-for="t in filterLabels" :key="t.id">
              <v-chip :color="viColor(t)" label small @click="skipToLabel(t, 0)" class="mb-1">
                <span class="caption">
                  {{ getSpeakerLabel(t.speakerTag) }}
                </span>
                <v-icon v-if="leftArrow(t)" right @click.stop="skipToLabel(t, -1)">
                  {{ leftArrow(t) }}
                </v-icon>
                <v-icon v-if="rightArrow(t)" @click.stop="skipToLabel(t, 1)">
                  {{ rightArrow(t) }}
                </v-icon>
              </v-chip>
              <p>{{ t.description }}</p>
            </div>
          </span>

          <v-chip-group v-else column>
            <span v-for="t in filterLabels" :key="t.id">
              <v-chip :class="
                  t.Kgraph && t.Kgraph.imageContentUrl ? 'squeeze pr-2' : ''
                " v-if="showChip(t)" :color="viColor(t)" label small @click="skipToLabel(t, 0)">
                <v-avatar v-if="t.Kgraph && t.Kgraph.imageContentUrl">
                  <v-icon small @click="flipKnowledge(t)">help</v-icon>
                </v-avatar>
                <v-img v-if="thumbnail" :src="'data:image/png;base64,' + t.description" cover></v-img>
                <span v-else class=" caption">{{ t.description }}</span>
            <v-icon v-if="leftArrow(t)" right @click.stop="skipToLabel(t, -1)">{{ leftArrow(t) }}</v-icon>
            <v-icon v-if="rightArrow(t)" @click.stop="skipToLabel(t, 1)">{{
              rightArrow(t)
              }}</v-icon>
            </v-chip>

            <span v-if="showKnowledge(t)">
              <kgraph-panel v-if="t.Kgraph" :item="t.Kgraph" flipper @kgshow="flipKnowledge(t)"></kgraph-panel>
              <div v-else>
                No Knowledge graph info for {{ t.description }}
                {{ t.entityID }}
              </div>
            </span>
        </span>
        </v-chip-group>
  </span>
  <span v-else-if="!isLoading">
    The labels are a lower confidence than the confidence ({{
    confidence
    }}) selected. Try moving the confidence slider left to see them.
  </span>
  <span v-else>
    <v-progress-linear v-if="isLoading" :indeterminate="true" color="accent" :active="isLoading"
      height="2"></v-progress-linear>
  </span>
  </v-card-text>
  </v-card>
  </span>
</template>
<script>
import Logo from '@/components/Logo'
import Kgraphpanel from '@/components/Kgraphpanel'
import { filteredViLabels } from '@/gql'
import { getIconColor, getIcon, settings } from '@/js/store'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { vxMaps } from '@/js/vxstore'
import Toolchipcount from '@/components/Toolchipcount'
import Hidedetail from '@/components/Hidedetail'
import { SearchUtils } from '@/js'
import { default as Pq } from 'p-queue'
import delay from 'delay'
const SKIP_DELAY = 1000

export default {
  components: {
    logo: Logo,
    'tool-chip-count': Toolchipcount,
    'hide-detail': Hidedetail,
    'kgraph-panel': Kgraphpanel,
  },
  props: {
    editable: Boolean,
    fmid: {
      type: String,
    },
    // identifies the kind of label to be displayed
    labelType: {
      type: String,
      required: true,
    },
    labelCaption: {
      type: String,
      required: true,
    },
    // this is a summary of counts by type to avoid the query if its not openedup
    count: Number,
    dirty: Boolean,
    // if true then treat the description as an image
    thumbnail: Boolean
  },

  methods: {
    // if it's a transcription, we'll want the thing to be able to play through
    getDelay(label, reviewMode) {
      if (label && reviewMode === 'play') {
        // if the thing is playing, then we'll hang around for the length of a transcript
        const seg = label.segments[label.playIndex]
        return this.playerStats.playing
          ? Math.max(SKIP_DELAY, 1000 * (seg.endTime - seg.startTime))
          : SKIP_DELAY
      } else {
        return SKIP_DELAY
      }
    },
    manageReview(reviewMode) {
      if (this.isReviewing) {
        this.ffq.add(() => {
          // make sure it's still reviewing by the time his turn comes
          if (this.isReviewing) {
            // these are just getting lined up here -
            // they wont actually get actioned until the seek for the next label is seeked
            if (reviewMode === 'play') {
              this.setPlayerAction('play')
            } else {
             this.setPlayerAction('pause')
            }
            // now move to next label
            this.skipToNextLabel()
          }
        })
        this.ffq.add(() => delay(this.getDelay(this.currentLabel, reviewMode)))
        this.ffq.add(() => this.manageReview(reviewMode))
      } else {
        this.ffq.clear()
        // signal the player to pause if its playing
        this.setPlayerAction('pause')
      }
    },
    flipReview(reviewMode) {
      this.reviewSelected = !this.reviewSelected
      this.manageReview(reviewMode)
    },
    showKnowledge(t) {
      return this.showingKnowledge && t.id === this.showingKnowledge.id
    },
    sameItemType(t) {
      return this.showingKnowledge && t.type === this.showingKnowledge.type
    },
    showChip(t) {
      // show the chip if its either the selected knowledge one, or there is no selected knowledge one
      return (
        !this.showingKnowledge || this.showKnowledge(t) || !this.sameItemType(t)
      )
    },
    flipKnowledge(t) {
      if (this.showKnowledge(t)) {
        // this means we are currently showing t, so show nothing
        this.showingKnowledge = null
      } else {
        // means we're not showing this one, so flip it to this one
        this.showingKnowledge = t
      }
    },
    getSpeakerLabel(speakerTag) {
      return speakerTag
        ? 'Voice ' + SearchUtils.columnLabelMaker(speakerTag)
        : 'Unknown speaker'
    },
    getIcon(name) {
      return getIcon(name)
    },
    getIconColor(name) {
      return getIconColor(name)
    },
    hide(pack) {
      this.setVActiveSub(pack.hide ? null : pack.propName)
    },
    viColor(shotLabel) {
      return getIconColor(
        shotLabel && this.isCurrentLabel(shotLabel) ? 'vicurrent' : 'vi',
      )
    },
    isCurrentLabel(shotLabel) {
      return this.currentLabel && this.currentLabel.id === shotLabel.id
    },
    leftArrow(shotLabel) {
      return shotLabel.playIndex ? 'arrow_left' : ''
    },
    rightArrow(shotLabel) {
      return shotLabel.playIndex < shotLabel.segments.length - 1
        ? 'arrow_right'
        : ''
    },

    skipToNextLabel() {
      // make it the current label
      // current label has shot label + play index
      if (!this.filterCount) return null

      if (!this.currentLabel) {
        this.currentLabel = this.filterLabels[0]
        this.currentLabel.playIndex = 0
      } else {
        // do we need to move to the next label?
        if (
          this.currentLabel.playIndex <
          this.currentLabel.segments.length - 1
        ) {
          // all we need to do is go to the next instance of this
          this.currentLabel.playIndex++
        } else {
          // we need to go to the next label
          // first reset the current playindex to the beginning of the set for cleanliness
          this.currentLabel.playIndex = 0

          // round robin to the next label
          this.currentLabel = this.filterLabels[
            (this.currentLabel.labelIndex + 1) % this.filterLabels.length
          ]
          this.currentLabel.playIndex = 0
        }
      }

      // go to the selected spot
      this.setPlaySegment(
        this.currentLabel.segments[this.currentLabel.playIndex],
      )
    },

    // skip to a specific label
    skipToLabel(shotLabel, skipBy) {
      // make it the current label
      if (skipBy) {
        // an arrow means there's more than 1 instance of the label
        shotLabel.playIndex = Math.abs(
          (shotLabel.playIndex + skipBy) % shotLabel.segments.length,
        )
      }
      this.currentLabel = shotLabel
      this.setPlaySegment(shotLabel.segments[shotLabel.playIndex])
    },

    // clears out any review activities
    clearReview() {
      this.reviewSelected = false
      this.ffq.clear()
    },

    ...mapMutations(vxMaps.mutations),
  },
  watch: {
    filteredLabels() {
      // filtered labels changed so we need to reset reviewing mode and current label
      this.currentLabel = null
      this.clearReview()
    },
    showCardDetail() {
      this.reviewSelected = false
      this.clearReview()
    },
  },
  data: () => ({
    showingKnowledge: null,
    currentLabel: null,
    ViLabels: null,
    reviewSelected: false,
    ffq: new Pq({
      concurrency: 1,
    }),
  }),

  computed: {
    // if review mode is active
    isReviewing() {
      return this.reviewSelected && this.showCardDetail
    },
    // explode shot labels to look like regular labels
    explodeLabels() {

      if (!this.filteredLabels || this.labelType !== 'shot') return null

      const terd = this.filteredLabels
        .reduce((p, c) => {
          c.segments.forEach((f, segmentIndex) => {
            p.push({
              segments: [
                {
                  ...f,
                  explodeIndex: p.length,
                  segmentIndex,
                },
              ],
              playIndex: 0,
              description: Math.round(10 * f.startTime) / 10,
              source: c,
              // need to make up some new id as its exploded
              id: c.id + '_' + segmentIndex,
              labelIndex: p.length,
            })
          })
          return p
        }, [])
        .sort((a, b) => a.segments[0].startTime - b.segments[0].startTime)
      return terd
    },

    // return labels filtered by confidence levels
    // and patched so that shot labels look like regular labels
    filterLabels() {

      return this.labelType === 'shot'
        ? this.explodeLabels
        : this.filteredLabels
    },

    // remove labels that don't meet the confidence threshold
    filteredLabels() {

      if (!this.someLabels) return null
      const terd =
        this.someLabels &&
        this.viLabelData
          .map((f) => ({
            ...f,
            playIndex: 0,
            // shot hasnt got a confidence level
            segments: f.segments.filter(
              (g) =>
                g.confidence >= this.confidence || this.labelType === 'shot',
            ),
          }))
          .filter((f) => f.segments.length)
          .sort((a, b) => a.segments[0].startTime - b.segments[0].startTime)
          .map((f, labelIndex) => {
            return {
              ...f,
              labelIndex,
            }
          })
      return terd
    },

    isLoading() {
      // can be used to detect if data is being fetched
      return this.$apollo.loading
    },

    showCard() {
      return (
        this.showLabels &&
        (this.vActiveSub === this.labelType || !this.vActiveSub)
      )
    },
    showCardDetail() {
      return (
        this.showLabels &&
        (this.labelType ? this.vActiveSub === this.labelType : this.vActiveSub)
      )
    },
    someLabels() {
      return this.viLabelData && this.viLabelData.length
    },
    filterCount() {
      return this.filterLabels && this.filterLabels.length
    },
    showff() {
      return this.filterCount && this.showCardDetail
    },

    showLabels() {
      return this.bigActiveSection === 'labelsection'
    },
    tooltips() {
      return settings.tooltips
    },
    labelColor() {
      return getIconColor('labels')
    },
    viLabelData() {
      return this.ViLabels
    },
    filmMasterID() {
      return this.fmid
    },
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters)
  },
  apollo: {
    ViLabels: {
      skip() {
        return !this.filmMasterID || !this.showCardDetail
      },
      query: filteredViLabels,
      fetchPolicy() {
        return this.dirty ? 'cache-and-network' : 'cache-first'
      },
      variables() {
        const filters =  [
          {
            valueKey: 'filmMasterID',
            value: this.filmMasterID,
          },
          {
            valueKey: 'type',
            value: this.labelType,
          }
        ]
        const vars = {
          filters,
          limit: 2000
        }
        return vars
      }
    },
  },
}
</script>
